var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.mode === "DESIGN"
      ? _c(
          "div",
          [
            _c(
              "draggable",
              _vm._b(
                {
                  staticClass: "l-drag-from",
                  attrs: { list: _vm._items, group: "form" },
                  on: {
                    start: function ($event) {
                      _vm.drag = true
                      _vm.selectFormItem = null
                    },
                    end: function ($event) {
                      _vm.drag = false
                    },
                  },
                },
                "draggable",
                { animation: 300, chosenClass: "choose", sort: true },
                false
              ),
              _vm._l(_vm._items, function (cp, id) {
                return _c(
                  "div",
                  {
                    key: id,
                    staticClass: "l-form-item",
                    style: _vm.getSelectedClass(cp),
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.selectItem(cp)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "l-form-header" },
                      [
                        _c("p", [
                          cp.props.required
                            ? _c("span", [_vm._v("*")])
                            : _vm._e(),
                          _vm._v(_vm._s(cp.title)),
                        ]),
                        _c("div", { staticClass: "l-option" }, [
                          _c("i", {
                            staticClass: "el-icon-close",
                            on: {
                              click: function ($event) {
                                return _vm.delItem(id)
                              },
                            },
                          }),
                        ]),
                        _c("form-design-render", { attrs: { config: cp } }),
                      ],
                      1
                    ),
                  ]
                )
              }),
              0
            ),
            _c(
              "div",
              {
                staticStyle: {
                  color: "#c0bebe",
                  "text-align": "center",
                  width: "90%",
                  padding: "5px",
                },
              },
              [_vm._v("☝ 拖拽控件到布局容器内部")]
            ),
          ],
          1
        )
      : _c(
          "div",
          _vm._l(_vm.__items, function (rows, rsi) {
            return _c(
              "el-row",
              { key: rsi + "_rows", attrs: { gutter: 20 } },
              _vm._l(rows, function (item, ri) {
                return _c(
                  "el-col",
                  { key: ri + "_row", attrs: { span: 24 / rows.length } },
                  [
                    item.name !== "SpanLayout" && item.name !== "Description"
                      ? _c(
                          "el-form-item",
                          {
                            key: item.name + ri,
                            attrs: { prop: item.id, label: item.title },
                          },
                          [
                            _c("form-design-render", {
                              attrs: { mode: _vm.mode, config: item },
                              model: {
                                value: _vm._value[item.id],
                                callback: function ($$v) {
                                  _vm.$set(_vm._value, item.id, $$v)
                                },
                                expression: "_value[item.id]",
                              },
                            }),
                          ],
                          1
                        )
                      : _c("form-design-render", {
                          attrs: { mode: _vm.mode, config: item },
                          model: {
                            value: _vm._value,
                            callback: function ($$v) {
                              _vm._value = $$v
                            },
                            expression: "_value",
                          },
                        }),
                  ],
                  1
                )
              }),
              1
            )
          }),
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }